<template>
  <Dialog v-model="visible" persistent scrollable>
    <template slot="title">
      <span class="title">{{$t('settings')}}</span>
    </template>
    <v-form class="py-2" v-model="valid">
      <NameTextField v-model="name"></NameTextField>
    </v-form>
    <template slot="actions">
      <v-spacer></v-spacer>
      <v-btn outlined color="primary" :loading="submitting" :disabled="!canSubmit" @click="submit">{{ $t('submit') }}</v-btn>
    </template>
  </Dialog>
</template>

<script>
import User from '@/components/auth/User'
import BaseDialog from '@/components/utils/dialog/BaseDialog'
import Dialog from '@/components/utils/dialog/Dialog'
import NameTextField from '@/components/utils/NameTextField'

export default {
  name: 'SceneSettingDialog',
  mixins: [User, BaseDialog],
  components: {
    Dialog,
    NameTextField
  },
  props: {
    device: {
      type: String,
      required: true
    },
    sceneId: {
      type: String
    }
  },
  data() {
    return {
      valid: false,
      submitting: false,
      name: null
    }
  },
  watch: {
    rawName(val) {
      if (this.submitting) {
        if (val == this.name) {
          this.visible = false;
        }
      }
    }
  },
  computed: {
    config() {
      return (this.userDevice[this.device] || {}).config || {};
    },
    rawName() {
      return (this.config[this.sceneId] || {}).name;
    },
    isNameChanged() {
      return this.rawName != this.name;
    },
    canSubmit() {
      return this.valid && this.isNameChanged;
    },
  },
  methods: {
    submit() {
      this.submitting = true;
      if (this.isNameChanged) this.configDevice({
        version: 1,
        timestamp: new Date().getTime(),
        device: {
          id: this.device
        },
        agent: {
          id: this.userId
        },
        endpoints: {
          [this.sceneId]: {
            name: this.name
          }
        }
      });
    }
  },
  mounted() {
    this.name = this.rawName;
  }
}
</script>